// material-ui
import { styled, Theme, CSSObject } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// types
import { ThemeMode } from '@app/types/config';
import { drawerWidth } from '@shared/constants/theme';

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  borderRight: '1px solid #eaecf0',
  zIndex: 1099,
  overflowX: 'hidden',
  background: `linear-gradient(to top, #ecf4f9 0%, #ecf4f9 60%, white 100%)`,
  boxShadow:
    theme.palette.mode === ThemeMode.DARK ? theme.customShadows.z1 : 'none',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen + 200,
  }),
});

const closedMixin = (theme: Theme): CSSObject => ({
  borderRight: 'none',
  zIndex: 1099,
  background: theme.palette.background.default,
  overflowX: 'hidden',
  width: 72,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen + 200,
  }),
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  borderRight: '0px',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      display: 'flex',
      flexDirection: 'column',
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      display: 'flex',
      flexDirection: 'column',
    },
  }),
}));

export default MiniDrawerStyled;
